import React from 'react';
import PropTypes from 'prop-types';
import CrewCard from './CrewCard';

const CrewsList = ({
  crews,
  selectedCrew,
  onCrewSelect,
  onCreateCrew,
  onEditCrew,
  onDeleteCrew,
  canCreate = true,
  canEdit = true,
}) => {
  return (
    <div className="flex h-full flex-col rounded-lg border border-gray-200 bg-white shadow-sm">
      <div className="border-b border-gray-200 p-4">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-gray-900">Crews</h2>
          {canCreate && (
            <button
              className="rounded-lg bg-blue-600 px-4 py-2 font-medium text-white transition-colors hover:bg-blue-700"
              onClick={onCreateCrew}
            >
              Create Crew
            </button>
          )}
        </div>
      </div>

      <div className="flex-1 space-y-4 overflow-y-auto p-4">
        {crews.map((crew) => (
          <CrewCard
            key={crew.id}
            crew={crew}
            isSelected={selectedCrew?.id === crew.id}
            onSelect={onCrewSelect}
            onEdit={onEditCrew}
            onDelete={onDeleteCrew}
            canEdit={canEdit}
          />
        ))}
        {crews.length === 0 && (
          <div className="py-12 text-center text-gray-500">
            <p className="mb-2 text-lg">No crews created yet</p>
            {canCreate ? (
              <button
                className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700"
                onClick={onCreateCrew}
              >
                Create your first crew
              </button>
            ) : (
              <p className="text-sm">You do not have permission to create crews.</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

CrewsList.propTypes = {
  crews: PropTypes.array.isRequired,
  selectedCrew: PropTypes.object,
  onCrewSelect: PropTypes.func.isRequired,
  onCreateCrew: PropTypes.func.isRequired,
  onEditCrew: PropTypes.func.isRequired,
  onDeleteCrew: PropTypes.func.isRequired,
  canCreate: PropTypes.bool,
};

export default CrewsList;
